import { createAction, props } from '@ngrx/store';

export const getCompanyLogisticData = createAction('[Shared] getCompanyLogisticData');
export const getCompanyLogisticDataSuccess = createAction('[Shared] getCompanyLogisticDataSuccess');
export const getCompanyLogisticDataFail = createAction('[Shared] getCompanyLogisticDataFail', props<{ error: any }>());
